import React from 'react'
import PropTypes from 'prop-types';
import DropdownItem from '../dropdown-item/dropdownItem'
import edit from "./images/edit.svg"

const LocationCard = ({isLocationModal, setIsLocationModal, value = 'Chennai', userLocation='Chennai'}) => {

  function setLocationDetails() {
    setIsLocationModal(!isLocationModal);

  }
  return (
    <div className='bg-white p-3 w-40 rounded-lg drop-shadow-sm cursor-pointer' onClick={setLocationDetails}>
        <div className='flex gap-4 items-center justify-center'>
          <DropdownItem image={require(`../../containers/dropdown/images/${userLocation.toLowerCase()}.svg`)} value={userLocation} className={{text: 'italic font-medium text-rose-700', background: 'flex items-center gap-3'}}/>
          <img src={edit}></img>
        </div>
    </div>
  )
}

LocationCard.propTypes = {
  isLocationModal : PropTypes.bool,
  setIsLocationModal : PropTypes.func,
  value: PropTypes.string
};


export default LocationCard